import { isProduction } from '..';
import type { AppConfig } from '../types';

export default {
  zone: 'anz-2',
  defaultLocale: 'en-NZ',
  availableLocales: ['en-NZ'],
  timedBanners: {},
  zoneFeatures: {
    AUTO_SELECT_SPLIT_VIEW_FIRST_JOB: false,
    ENTRY_LEVEL_BADGE: true,
    HOMEPAGE_BANNER_TYPE: 'single',
    JOBSEARCH_ASSIST: false,
    KEYWORD_AUTOSUGGEST_V2: true,
    LMIS_ENABLED: true,
    LOGGED_OUT_RECS: false,
    NUDGE_ENABLED: true,
    NUDGE_INTENT: false,
    REMOTE_SEARCH_FILTER_NEW_LABEL: false,
    REMOTE_SEARCH_FILTER: true,
    SEARCH_PAGE_SIZE: 22,
    SERP_JOBCARD_INFO_DENSITY_1: false,
    SHOW_FLOATING_SAVE_SEARCH: true,
    SHOW_JOBCARD_TEASER_IN_SPLITVIEW: true,
    SHOW_MARKETING_AD_SPLIT_VIEW: true,
  },
  BRANCH_IO_KEY: isProduction
    ? 'key_live_hpVf26efkYxTQTj88NJzZpchsqglHGRe'
    : 'key_test_khOf96nlb9tQIPl47VZiEcbpszklPUNw',
  GPT_ACCOUNT_ID: '23030987465',
} as AppConfig;
